import type React from 'react';
import type { ChangeEvent } from 'react';

import { SearchIcon } from '@vlabs/icons';
import type { InputProps } from '@vlabs/uikit/components/controls/input/Input';
import { Input } from '@vlabs/uikit/components/controls/input/Input';
import { useTranslation } from 'react-i18next';

import { useSourceFilters } from './useSourceFilters';

function SourceGroupSearchInput(props: InputProps): React.JSX.Element {
  const { t } = useTranslation();
  const { updateFiltersDebounced } = useSourceFilters();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (value) {
      updateFiltersDebounced({ names: [value], page: 1 });
    } else {
      updateFiltersDebounced({ names: undefined, page: 1 });
    }
  };

  return (
    <Input
      icon={<SearchIcon />}
      onChange={handleChange}
      placeholder={t('entities:source_filters.search.placeholder')}
      size="small"
      {...props}
    />
  );
}

export { SourceGroupSearchInput };
